import React, { useEffect } from "react";
import { Button, FormGroup, Input, Label } from "reactstrap";
import { CreateGuide, CreateGuideRequest, GetGuide, UpdateGuide, UpdateGuideRequest } from "./GuideStore";
import { useNavigate, useParams } from "react-router-dom";
import OrganizationContextSwitcher from "../organizations/ContextSwitcher";

const GuidesEdit = () => {
    const { id } = useParams();

    useEffect(() => {
        if (id) {
            GetGuide(id).then((res) => {
                setName(res.value.name);
                setOrganizationID(res.value.organizationID);
                setKey(res.value.key);
                setGuideURI(res.value.guideURI);
                setThumbnailURI(res.value.thumbnailURI);
            });
        }
    }, [id]);

    const [name, setName] = React.useState("");
    const [organizationID, setOrganizationID] = React.useState("");
    const [key, setKey] = React.useState("");
    const [guideURI, setGuideURI] = React.useState("");
    const [thumbnailURI, setThumbnailURI] = React.useState("");

    const navigate = useNavigate();

    const update = async () => {
        var res = await UpdateGuide({ id, name, organizationID, key, guideURI, thumbnailURI } as UpdateGuideRequest);
        navigate("/guides");
    };

    return (
        <div>
            <OrganizationContextSwitcher></OrganizationContextSwitcher>
            <FormGroup>
                <Label>Name</Label>
                <Input value={name} onChange={(e) => setName(e.target.value)}></Input>
            </FormGroup>
            <FormGroup>
                <Label>Organization</Label>
                <Input value={organizationID} onChange={(e) => setOrganizationID(e.target.value)}></Input>
            </FormGroup>
            <FormGroup>
                <Label>Key</Label>
                <Input value={key} onChange={(e) => setKey(e.target.value)}></Input>
            </FormGroup>
            <FormGroup>
                <Label>Guide URI</Label>
                <Input value={guideURI} onChange={(e) => setGuideURI(e.target.value)}></Input>
            </FormGroup>
            <FormGroup>
                <Label>Thumbnail URI</Label>
                <Input value={thumbnailURI} onChange={(e) => setThumbnailURI(e.target.value)}></Input>
            </FormGroup>
            <Button color="primary" onClick={update}>
                Update
            </Button>
        </div>
    );
};

export default GuidesEdit;
